import { BaseError } from "./errorBase";

const delay = (delay: number) =>
  new Promise((resolve) => setTimeout(resolve, delay));

class ErrorHandler {
  public async handleError(err: Error): Promise<void> {
    await delay(100);
    // eslint-disable-next-line no-console
    console.error(err);
    // await sendMailToAdminIfCritical()
    // await sendEventsToSentry()
  }

  public isTrustedError(error: Error) {
    if (error instanceof BaseError) {
      return error.isOperational;
    }
    return false;
  }
}

export const errorHandler = new ErrorHandler();
